import PropTypes from 'prop-types'
import React, { Component } from 'react'
import classNames from 'classnames'
import Hub from 'base/hub'
import Event from 'base/event'
import FadeInOut from 'base/react/animations/fade_in_out'

export default class Modal extends Component {
  static propTypes = {
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    top: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    minHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    overflowY: PropTypes.string,
    overflowX: PropTypes.string,
    modalBackgroundColor: PropTypes.string,
    onRequestClose: PropTypes.func,
    backgroundClass: PropTypes.string,
    containerClass: PropTypes.string,
    closeIcon: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    shouldFadeIn: PropTypes.bool,
    useBaseModalClass: PropTypes.bool,
    isFlyoutCart: PropTypes.bool,
  }

  static defaultProps = {
    backgroundClass: 'modal__bg--default',
    modalBackgroundColor: 'white',
    width: 600,
    minHeight: 600,
    overflowX: 'auto',
    overflowY: 'auto',
    closeIcon: '×',
    shouldFadeIn: true,
    useBaseModalClass: true,
    isFlyoutCart: false,
  }

  componentDidMount() {
    Hub.pub(Event.Modal.MODAL_OPENED)
    document.addEventListener('keydown', this.handleKeyDown)
  }

  componentWillUnmount() {
    Hub.pub(Event.Modal.MODAL_CLOSED)
    document.removeEventListener('keydown', this.handleKeyDown)
  }

  handleKeyDown = e => {
    if (e.keyCode === 27) {
      !!this.props.onRequestClose && this.props.onRequestClose()
    }
  }

  handleCloseOnBackgroundClick = event => {
    if ([this.backgroundRef, this.closeIconRef].includes(event.target)) {
      this.props.onRequestClose && this.props.onRequestClose()
    }
  }

  render() {
    const modalStyles = {
      backgroundColor: this.props.modalBackgroundColor,
      width: this.props.width,
      minHeight: this.props.minHeight,
      height: this.props.height,
      overflowX: this.props.overflowX,
      overflowY: this.props.overflowY,
    }

    const containerClass = this.props.useBaseModalClass
      ? classNames('modal__container', this.props.containerClass)
      : this.props.containerClass
    const modalBackgroundClass = classNames('modal__bg', this.props.backgroundClass)

    return (
      <FadeInOut appear={this.props.shouldFadeIn}>
        <div
          className={modalBackgroundClass}
          ref={el => (this.backgroundRef = el)}
          onClick={this.handleCloseOnBackgroundClick}
        >
          <div className={containerClass} style={modalStyles}>
            {this.props.closeIcon && (
              <div
                ref={el => (this.closeIconRef = el)}
                className="modal__close-button"
                onClick={
                  this.props.isFlyoutCart
                    ? () => {
                        Hub.pub(Event.Navigation.CART_DROP_DOWN_X_CLICK)
                      }
                    : null
                }
              >
                {this.props.closeIcon}
              </div>
            )}
            {this.props.children}
          </div>
        </div>
      </FadeInOut>
    )
  }
}
